import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import PotentialScheduleIcon from '@/svg-icons/PotentialSchedule';

const PotentialScheduleSection = ({ data }) => (
    <div className="w-full">
      <div className="font-bold text-[calc(6px+0.4vw)] my-[0.6vw] flex items-center">
        <PotentialScheduleIcon 
          viewBox="0 0 34.016 34.016" 
          className="text-gray-700 mr-2 w-6 h-6 shrink-0" 
        />
        <FormattedMessage id="potentialSchedule" />
      </div>

      <div className="flex flex-wrap text-[#858585] text-[calc(6px+0.4vw)] my-[1vw] pl-[calc(14px+1.8vw)]">
        <div className="w-1/2 mb-[1vw]" data-cy="order-details-potential-schedule-date1">
          <div className="font-bold">
            <FormattedMessage id="date1" />
          </div>
          {data.date1}
        </div>

        <div className="w-1/2 mb-[1vw]" data-cy="order-details-potential-schedule-time1">
          <div className="font-bold">
            <FormattedMessage id="time1" />
          </div>
          {data.time1}
        </div>

        <div className="w-1/2 mb-[1vw]" data-cy="order-details-potential-schedule-date2">
          <div className="font-bold">
            <FormattedMessage id="date2" />
          </div>
          {data.date2}
        </div>

        <div className="w-1/2 mb-[1vw]" data-cy="order-details-potential-schedule-time2">
          <div className="font-bold">
            <FormattedMessage id="time2" />
          </div>
          {data.time2}
        </div>
      </div>
    </div>
);

PotentialScheduleSection.propTypes = {
  data: PropTypes.object.isRequired,
};

export default PotentialScheduleSection;
